import {z} from '@hono/zod-openapi';

import {amount} from './amount';

export const InventoryTurnoverMonthSchema = z
  .object({
    month: z.string().regex(/^\d{4}-\d{2}$/),
    asOf: z.string().date(),
    costOfIssues: amount.nullable(),
    averageInventoryValue: amount.nullable(),
    inventoryTurnover: amount.nullable(),
    inventoryDays: amount.nullable(),
    complete: z.boolean(),
  })
  .openapi('InventoryTurnoverMonth');

export type InventoryTurnoverMonth = z.infer<typeof InventoryTurnoverMonthSchema>;
